import styled from 'styled-components';
import { Pulse } from './Pulse';
export var SkeletonChart = styled(Pulse).withConfig({
  displayName: "SkeletonChart",
  componentId: "sc-erllsl-0"
})(["max-width:100%;min-height:360px;border-radius:5px;"]);